module.exports = __webpack_public_path__ + "static/media/circular-std-book.f053c365.svg";